import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';

var SwitchState;
(function (SwitchState) {
    SwitchState[SwitchState["None"] = 0] = "None";
    SwitchState[SwitchState["Toggled"] = 1] = "Toggled";
    SwitchState[SwitchState["Untoggled"] = 2] = "Untoggled";
})(SwitchState || (SwitchState = {}));
class SwitchComponent {
    constructor() {
        this.SwitchState = SwitchState;
        this.stateChange = new EventEmitter();
    }
    toggle(stateClicked) {
        if (this.disabled) {
            return;
        }
        let nextState;
        if (this.state !== SwitchState.None) {
            nextState = this.state === SwitchState.Toggled ?
                SwitchState.Untoggled :
                SwitchState.Toggled;
        }
        else {
            nextState = stateClicked;
        }
        this.stateChange.emit(nextState);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SwitchComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: SwitchComponent, selector: "yc-switch", inputs: { state: "state", toggledText: "toggledText", untoggledText: "untoggledText", compact: "compact", disabled: "disabled" }, outputs: { stateChange: "stateChange" }, ngImport: i0, template: "<div class=\"wrapper\" [class.compact]=\"compact\" [class.disabled]=\"disabled\">\n  <label class=\"toggled-label\" [class.selected]=\"state !== SwitchState.Untoggled\" (click)=\"toggle(SwitchState.Toggled)\">\n    {{ toggledText }}\n  </label>\n  <div class=\"toggle\" (click)=\"toggle(SwitchState.None)\"></div>\n  <label class=\"untoggled-label\" [class.selected]=\"state !== SwitchState.Toggled\" (click)=\"toggle(SwitchState.Untoggled)\">\n    {{ untoggledText }}\n  </label>\n</div>\n", styles: [".wrapper{display:flex;border:1px solid gainsboro;border-radius:.25rem;height:2rem;align-items:center;background-color:green;width:4.75rem}.wrapper.compact{height:1.5rem;width:3.25rem}.wrapper.compact .toggle{height:1.5rem;min-width:.5rem}.wrapper.disabled{background-color:gray!important}label{margin:0;overflow:hidden;width:0px;transition:.25s;text-align:center;color:#fff;font-weight:700}label.selected{width:4rem;margin:.625rem;opacity:1}label.toggled-label{margin-right:0;margin-left:-1px}label.untoggled-label{margin-left:0;margin-right:-1px}div.toggle{background-color:#fff;min-width:.75rem;height:2rem;border-radius:.25rem;border:1px solid gainsboro}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SwitchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'yc-switch', template: "<div class=\"wrapper\" [class.compact]=\"compact\" [class.disabled]=\"disabled\">\n  <label class=\"toggled-label\" [class.selected]=\"state !== SwitchState.Untoggled\" (click)=\"toggle(SwitchState.Toggled)\">\n    {{ toggledText }}\n  </label>\n  <div class=\"toggle\" (click)=\"toggle(SwitchState.None)\"></div>\n  <label class=\"untoggled-label\" [class.selected]=\"state !== SwitchState.Toggled\" (click)=\"toggle(SwitchState.Untoggled)\">\n    {{ untoggledText }}\n  </label>\n</div>\n", styles: [".wrapper{display:flex;border:1px solid gainsboro;border-radius:.25rem;height:2rem;align-items:center;background-color:green;width:4.75rem}.wrapper.compact{height:1.5rem;width:3.25rem}.wrapper.compact .toggle{height:1.5rem;min-width:.5rem}.wrapper.disabled{background-color:gray!important}label{margin:0;overflow:hidden;width:0px;transition:.25s;text-align:center;color:#fff;font-weight:700}label.selected{width:4rem;margin:.625rem;opacity:1}label.toggled-label{margin-right:0;margin-left:-1px}label.untoggled-label{margin-left:0;margin-right:-1px}div.toggle{background-color:#fff;min-width:.75rem;height:2rem;border-radius:.25rem;border:1px solid gainsboro}\n"] }]
        }], propDecorators: { state: [{
                type: Input
            }], toggledText: [{
                type: Input
            }], untoggledText: [{
                type: Input
            }], compact: [{
                type: Input
            }], disabled: [{
                type: Input
            }], stateChange: [{
                type: Output
            }] } });

class SwitchModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SwitchModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: SwitchModule, declarations: [SwitchComponent], imports: [CommonModule], exports: [SwitchComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SwitchModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SwitchModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        SwitchComponent
                    ],
                    exports: [
                        SwitchComponent
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SwitchComponent, SwitchModule, SwitchState };
